import { render, staticRenderFns } from "./CnaeMultipleSelector.vue?vue&type=template&id=127c0f2a&scoped=true"
import script from "./CnaeMultipleSelector.vue?vue&type=script&lang=js"
export * from "./CnaeMultipleSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127c0f2a",
  null
  
)

export default component.exports